/**
 * Rendu du contenu éditorial.
 *
 * Rien ici n'écrit de texte : tout vient du fichier de contenu, validé par
 * `content/schema.ts`. Un contenu invalide ne se rattrape pas en silence — la
 * page affiche ce qui manque, comme elle affiche les motifs d'un refus de
 * comparaison. Un site qui masque ses trous finit par les garder.
 */

import type { ContentSection, ProtocolSection } from "../content/schema.js";
import { fr } from "../i18n/fr.js";
import { escape } from "./format.js";

function paragraphs(section: ContentSection): string {
  return section.paragraphs.map((text) => `<p>${escape(text)}</p>`).join("");
}

export function renderContentSection(section: ContentSection): string {
  return `<div class="verlet-prose">${paragraphs(section)}</div>`;
}

export function renderProtocol(protocol: ProtocolSection): string {
  const steps = protocol.steps.map((step) => `<li>${escape(step)}</li>`).join("");
  return [
    `<div class="verlet-prose">`,
    paragraphs(protocol),
    `<ol class="verlet-steps">${steps}</ol>`,
    `</div>`,
  ].join("");
}

export function renderContentProblems(problems: readonly string[]): string {
  const items = problems.map((problem) => `<li>${escape(problem)}</li>`).join("");
  return [
    `<div class="verlet-refusal" role="note">`,
    `<p class="verlet-refusal__title">${escape(fr.contentInvalid)}</p>`,
    `<ul>${items}</ul>`,
    `</div>`,
  ].join("");
}
